export default function deduplicateGets(client) {
  const pending = new Map();
  const get = client.get.bind(client);
  client.get = (url, config = {}) => {
    const key = JSON.stringify([url, config.params || {}, localStorage.getItem("lasepa_admin_token")]);
    if (pending.has(key)) return pending.get(key);
    const request = get(url, config).finally(() => pending.delete(key));
    pending.set(key, request);
    return request;
  };
  return client;
}
